import { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function FaqSection({ wedding }) {
  const faq = wedding.faq || [];
  const [openId, setOpenId] = useState(null);
  if (!faq.length) return null;

  return (
    <section className="py-16 sm:py-20 px-6 sm:px-12 bg-white" data-testid="faq-section">
      <div className="max-w-2xl mx-auto">
        <p className="eyebrow mb-4 text-center">Domande frequenti</p>
        <h2 className="font-wed text-3xl sm:text-4xl mb-10 text-center">Da sapere</h2>
        <div className="space-y-2">
          {faq.map((f) => (
            <div key={f.id} className="border rounded-2xl overflow-hidden" style={{ borderColor: "#e3ddd2" }} data-testid={`faq-item-${f.id}`}>
              <button
                type="button"
                onClick={() => setOpenId((id) => (id === f.id ? null : f.id))}
                className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left"
              >
                <span className="font-medium text-sm sm:text-base">{f.domanda}</span>
                <ChevronDown size={18} className={`shrink-0 transition-transform duration-200 ${openId === f.id ? "rotate-180" : ""}`} style={{ color: "var(--wed-primary)" }} />
              </button>
              {openId === f.id && f.risposta && (
                <p className="px-5 pb-4 text-sm text-neutral-500 leading-relaxed whitespace-pre-line">{f.risposta}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
